import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/nature-banner-xl.avif")